<template>
    <div class="card w-100">
        <div class="card-body d-flex flex-column">
            <accent-box :title="$t('common.travelAdvisor.yourTravelAdvisor')" class="travel-advisor flex-grow-1">
                <div class="row">
                    <div class="travel-advisor-logo col-12 align-self-center text-center mb-2">
                        <img v-if="agent.logoUrl" :src="agent.logoUrl" alt="travel advisor's logo"/>
                        <div v-else class="d-flex text-secondary travel-advisor-logo-placeholder">
                            <font-awesome-icon :icon="['fad', 'plane-engines']" class="fa-2x me-2" />
                            <h4 class="mb-0">{{agent.companyNameOverride ?? agent.company.name}}</h4>
                        </div>
                    </div>
                    <div class="travel-advisor-contact col-md">

                        <div class="lead">{{agent.fullName}}</div>
                        <div>{{agent.companyNameOverride ?? agent.company.name}}</div>
                        <div>
                            <font-awesome-icon :icon="['fal', 'square-envelope']" class="fa-lg text-dark me-1"/>
                            <span>
                                <a :href="`mailto:${agent.email}`" class="ps-1">{{agent.email}}</a>
                            </span>
                        </div>
                        <div>
                            <font-awesome-icon :icon="['fal', 'square-phone']" class="fa-lg text-dark me-1"/>
                            {{agent.phone}}
                        </div>
                    </div>
                    <!-- Show in MD & LG breakpoints only to fill empty space -->
                    <div class="travel-advisor-address col-md d-none d-md-block d-xl-none">
                        <div class="lead">{{ $t('common.travelAdvisor.address')}}</div>
                        <div>{{agent.streetAddress}}</div>
                        <div v-if="agent.streetAddress2">{{agent.streetAddress2}}</div>
                        <div>{{agent.city}}, {{agent.state}} {{agent.postalCode}}</div>
                    </div>
                </div>
            </accent-box>
        </div>
    </div>
</template>

<script>
import AccentBox from "@/components/common/AccentBox";
export default {
    name: 'TravelAdvisor',
    components: {AccentBox},
    props: {
        agent: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.travel-advisor {
    .travel-advisor-logo {
        img {
            max-height: 110px;
            max-width: 275px;
            text-align: center;
            object-fit: cover;
        }

        .travel-advisor-logo-placeholder {
            min-width: 0;
            h4 {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .travel-advisor-address {
        border-left: 1px solid $border-color;
    }
}
</style>